import { datadogRum } from "@datadog/browser-rum"
import { reactPlugin } from "@datadog/browser-rum-react"

export function initDatadog() {
  let hostName = window.location.hostname
  // not initialize DataDog on localhost
  const isLocalhost =
    hostName === "localhost" || hostName === "127.0.0.1" || hostName.includes("localhost")
  if (isLocalhost) {
    console.log("[DataDog] Skipped initialization on localhost")
    return
  }

  const sessionSampleRate = Number(process.env.REACT_APP_DATA_DOG_SESSION_SAMPLE_RATE ?? 100)
  const sessionReplaySampleRate = Number(
    process.env.REACT_APP_DATA_DOG_SESSION_REPLAY_SAMPLE_RATE ?? 100
  )

  datadogRum.init({
    applicationId: "bfaaf717-592f-4c22-ada3-ec0527bce8d3",
    clientToken: "pub0b8c9441cf21d36ed9e5971f328bdae6",
    site: "datadoghq.eu",
    service: "chargeback-web-app",
    env: process.env.REACT_APP_DATA_DOG_PROJECT_ENVIRONMENT,
    version: "1.0.0",
    sessionSampleRate: sessionSampleRate,
    sessionReplaySampleRate: sessionReplaySampleRate,
    premiumSampleRate: sessionSampleRate,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
    plugins: [reactPlugin({ router: true })],
    allowedTracingUrls: [
      "https://api.dev.chargeback.io",
      "https://api.staging.chargeback.io",
      "https://api.chargeback.io"
    ],
    beforeSend: (event, context) => {
      if (event.type === "resource") {
        const url = event.resource?.url || ""
        const blocked = [
          "google.com",
          "googletagmanager.com",
          "google-analytics.com",
          "doubleclick.net",
          "facebook.net",
          "tiktokcdn-us.com",
          "ibyteimg.com",
          "firstpromoter.com",
          "youtube.com",
          "cookiebot.com",
          "twitter.com",
          "cdn-apple.com",
          "gstatic.com",
          "ads-twitter.com"
        ]
        if (blocked.some((domain) => url.includes(domain))) {
          return false
        }
      }
      return true
    }
  })

  datadogRum.startSessionReplayRecording()
}
